import { types, flow, getEnv } from 'mobx-state-tree'
// import
/**
 * Add Editable model if it doesn't have it.
 * @param notificationKey
 */
export const TabNotificationStore = (notificationKey = 'INVOICES') =>
  types
    .model({})
    .volatile(() => ({
      tabNotifications: [],
    }))
    .views((self) => ({
      get rootNotification() {
        return getEnv(self).notificationStore
      },
    }))
    .actions((self) => ({
      getNotifications() {
        self.tabNotifications = self.rootNotification.notifications.filter(
          (notification) => notification.type === notificationKey,
        )
      },
      markAllAsRead: flow(function* () {
        self.rootNotification.markAllAsRead({ type: notificationKey })
      }),
    }))
